var mem = {};

// mem.page, a naive MVC implementation
(function () {
  var pages = { },
    currentPage;

  mem.page = function (name, factoryMethod) {
    pages[name] = factoryMethod;
  };

  mem.showPage = function (name, options) {
    var page = pages[name];

    if (!page) throw { err: 'Page "' + name + '" not found.' };

    currentPage && currentPage.destroy && currentPage.destroy();

    currentPage = page(options);

    mem.render(currentPage.view || name + 'Template', currentPage.data || {});

    currentPage.init && currentPage.init();
  }
})();
